import React from 'react'
import PropTypes from 'prop-types'
import { getConstant } from 'commons/js/constants'
import CountrySwitch from 'commons/js/components/CountrySwitch'
import AppDownloadButton from './AppDownloadButton'

const AppDownloadButtonUSA = (props) => <AppDownloadButton {...props} campaign='elparking_web_cap_us_ios_ext_badge_descarga_app' />
const AppDownloadButtonESP = (props) => <AppDownloadButton {...props} campaign='elparking_web_cap_es_ios_ext_badge_descarga_app' />

const AppleStoreDownloadButton = ({ color, height }) => {
    const imageUri = `/images/app-buttons/app-store-badge-${color}-${getConstant('LANGUAGE')}.svg`
    const webUrl = getConstant('APPLE_STORE_ELPARKING_URI')
    return (
        <CountrySwitch
          usa={AppDownloadButtonUSA}
          col={AppDownloadButtonUSA}
          ecu={AppDownloadButtonUSA}
          esp={AppDownloadButtonESP}
          cri={AppDownloadButtonESP}
          imageUri={imageUri}
          height={height}
          alt='Apple Store'
          webUrl={webUrl}
          dataTest='download-app-ios-button'
        />
    )
}

AppleStoreDownloadButton.defaultProps = {
    color: 'black',
    height: '40px',
}

AppleStoreDownloadButton.propTypes = {
    color: PropTypes.string,
    height: PropTypes.string,
}

export default AppleStoreDownloadButton
